import axios from "@/configuration/axios";
import cognito from "@/configuration/cognito";
import env from "@/configuration/env";

export default {
  init: async () => {
    await env.init();
    await axios.init();
    await cognito.init();
  },
};
